import { render, staticRenderFns } from "./comprehensive.vue?vue&type=template&id=d9bcbd40&"
import script from "./comprehensive.vue?vue&type=script&lang=js&"
export * from "./comprehensive.vue?vue&type=script&lang=js&"
import style0 from "./comprehensive.vue?vue&type=style&index=0&id=d9bcbd40&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports